import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataFim = (): TabelaColuna => ({
  Chave: 'dataFim',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataFim)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Fim</div>
})
